import { QueryClient } from "@tanstack/react-query";
import { create } from "zustand";
import { AkatsukiClient } from "../customHooks/useInitApiClients/clients/akatsuki/types.js";

export type CloudRoutingDepsState = {
    queryClient?: QueryClient;
    akatsukiClient?: AkatsukiClient;
};

export const useCloudRoutingDeps = create<CloudRoutingDepsState>()(() => ({
    queryClient: undefined,
    akatsukiClient: undefined,
}));

export const setCloudRoutingDeps = (deps: { queryClient: QueryClient; akatsukiClient: AkatsukiClient }) => {
    useCloudRoutingDeps.setState(deps);
};
